module.exports = __webpack_public_path__ + "static/media/Patricia.a2626dc1.jpg";